import {isValid} from "./myga-session";
import {MM_QUESTION, QUESTION_VISUAL_ORIENTATION} from "./myga-model";
import {validateCondition} from "./validation";
import {isObject} from "./myga-utils";

const {NassauLog} = require("./myga-utils");

export const GET_DOC_WIDTH = () => {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

export const GET_DOC_HEIGHT = () => {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  );
}



const processDisplayBreakpoint = (val, defaultVal) => {
  if (isObject(val)) {
    if (val.hasOwnProperty('displayNarrow') && GET_DOC_WIDTH() <= 576) {
      return val.displayNarrow;
    }
    if (val.hasOwnProperty('displayWide')) {
      return val.displayWide
    }
  } else if (isValid(val)) {
    return val
  }
  return defaultVal
}

const processVisualOrientation = (orientation, val, defaultVal) => {
  if (isObject(val)) {
    if (val.hasOwnProperty('orientationVertical') && orientation === QUESTION_VISUAL_ORIENTATION.vertical) {
      return val.orientationVertical;
    }
    if (val.hasOwnProperty('orientationHorizontal') && orientation === QUESTION_VISUAL_ORIENTATION.horizontal) {
      return val.orientationHorizontal
    }
  } else if (isValid(val)) {
    return val
  }
  return defaultVal
}

const processLabelClassname = (question, classKey, defaultVal='') => {
  const label = question.label
  if (!isObject(label)) return defaultVal
  if (label.hasOwnProperty(classKey)) {
    const classname = label[classKey]
    return processVisualOrientation(_PROCESS_VISUAL_ORIENTATION(question), classname, defaultVal)
  }
  return defaultVal
}



const _PROCESS_TEXT_JUSTIFICATION = justification => {
  if (justification === 'center') return 'text-center';
  if (justification === 'right') return 'text-right';
  return 'text-left';
}
export const PROCESS_TEXT_JUSTIFICATION = _PROCESS_TEXT_JUSTIFICATION;

const _PROCESS_COL_WIDTH = width => {
  let processedWidth = processDisplayBreakpoint(width, '');
  return processedWidth === '' ? '' : `col-${processedWidth}`
}
export const PROCESS_COL_WIDTH = _PROCESS_COL_WIDTH;

const _PROCESS_TEXT_LAYOUT = question => {
  return isValid(question.label) ? `${_PROCESS_TEXT_JUSTIFICATION(question.label.justification)}` : '';
}
export const PROCESS_TEXT_LAYOUT = _PROCESS_TEXT_LAYOUT;

const _PROCESS_FLEX_JUSTIFICATION = justification => {
  if (justification === 'center') return 'justify-center';
  if (justification === 'right') return 'justify-right';
  return 'justify-left';
}
export const PROCESS_FLEX_JUSTIFICATION = _PROCESS_FLEX_JUSTIFICATION;

const _PROCESS_CHILDREN_LAYOUT = question => {
  return isValid(question.response) ? `${_PROCESS_FLEX_JUSTIFICATION(question.response.justification)}` : '';
}
export const PROCESS_CHILDREN_LAYOUT = _PROCESS_CHILDREN_LAYOUT;

const _PROCESS_VISUAL_ORIENTATION = question => {
  const vo = question.visualOrientation;
  return processDisplayBreakpoint(vo, QUESTION_VISUAL_ORIENTATION.vertical)
}
export const PROCESS_VISUAL_ORIENTATION = _PROCESS_VISUAL_ORIENTATION;

const _PROCESS_QUESTION_TEXT = question => {
  const label = question.label
  if (!isObject(label)) return label
  if (label.hasOwnProperty('text')) return label.text
  return ''
}
export const PROCESS_QUESTION_TEXT = _PROCESS_QUESTION_TEXT

const _PROCESS_QUESTION_CONTAINER_CLASSNAME = (question, defaultVal) => {
  return processLabelClassname(question, 'containerClassname', defaultVal)
}
export const PROCESS_QUESTION_CONTAINER_CLASSNAME = _PROCESS_QUESTION_CONTAINER_CLASSNAME

const _PROCESS_QUESTION_TEXT_CLASSNAME = (question, defaultVal) => {
  return processLabelClassname(question, 'textClassname', defaultVal)
}
export const PROCESS_QUESTION_TEXT_CLASSNAME = _PROCESS_QUESTION_TEXT_CLASSNAME

const _PROCESS_COL_LIMIT = limit => processDisplayBreakpoint(limit, 2)
export const PROCESS_COL_LIMIT = _PROCESS_COL_LIMIT

const _PROCESS_QUESTION_PLACEMENT = (question, placement) => {
  if (isValid(question.placement)) return question.placement === placement
  return 'Response' === placement
}
export const PROCESS_QUESTION_PLACEMENT_RESPONSE = questions => {
  return questions.filter(q => _PROCESS_QUESTION_PLACEMENT(q, 'Response'))
}
export const PROCESS_QUESTION_PLACEMENT_QUESTION = questions => {
  return questions.filter(q => _PROCESS_QUESTION_PLACEMENT(q, 'Question'))
}